import HeroSection from '../components/HeroSection';
import InnovativeSolutions from '../components/InnovativeSolutions';
import Gallery from '../components/Gallery';
import Services from '../components/Services';
import ContactBanner from '../components/ContactBanner';

const Home = () => {
    return (
    <>
        <HeroSection />
        <InnovativeSolutions />
        <Gallery />
        <Services />
        <ContactBanner />
    </>
    );
}

export default Home;
